module.exports = __webpack_public_path__ + "static/media/02._Pos_Bloc.deab625f.png";